import { AuthTokenState, AuthTokenTypes } from 'redux/actions/auth/authToken.d';
import { STORE_AUTH_TOKEN } from 'redux/actionTypes/authToken';

const INITIAL_STATE: AuthTokenState = {
  data: {
    authorization: '',
  },
};

function authTokenReducer(state = INITIAL_STATE, action: AuthTokenTypes): AuthTokenState {
  switch (action.type) {
    case STORE_AUTH_TOKEN: {
      return {
        ...state,
        data: { ...action.payload },
      };
    }
    default:
      return state;
  }
}

export default authTokenReducer;
